<template>
  <ul>
    <li
      v-for="(item, key, index) in items"
      :key="index"
      class="overflow-hidden"
    >
      <button
        @click="clickCollapseExpand"
        :class="[
          {
            'border-t-1' : (true === showDivider && 0 !== index),
            'py-3': true === showDivider,
          },
          'w-full'
        ]"
        type="button"
      >
        <slot
          name="button"
          :item="item"
        />
      </button>
      <div>
        <slot
          name="content"
          :item="item"
        />
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'adivare-accordion',
  props: {
    // collapsible items
    items: {
      type: Object,
      required: true,
    },
    // speed of collapsible item
    speed: {
      type: Number,
      default: 3,
      required: false,
    },
    // expand first collapsible item at initialization
    expandFirstItem: {
      type: Boolean,
      default: false,
      required: false,
    },
    // expand item when the button of accordion item has a checked radio button
    expandCheckedRadioButton: {
      type: Boolean,
      default: false,
      required: false,
    },
    // If false, only the first click in a sequence of clicks of the same button is registered.
    disableMultiToggle: {
      type: Boolean,
      default: true,
      required: false,
    },
    showDivider: {
      type: Boolean,
      default: false,
      required: false,
    }
  },
  data() {
    return {
      contentMaxHeightName: 'accordionMaxHeight',
      content: null,
      expandedItem: null,
    }
  },
  methods: {
    init() {
      Array.from(this.$el.children).forEach((item, index) => {
        this.content = item.lastElementChild;
        this.content.style.transition = `all ${(Math.round(this.content.scrollHeight * (1 / this.speed) * 0.3) / 100)}s linear`;
        Object.defineProperty(this.content, this.contentMaxHeightName, {
          value: this.content.scrollHeight ?? 0,
          writable: false
        });

        // expand first item during initialisation
        // or expand checked radiobutton during initialisation
        if (
          (true === this.expandFirstItem && 0 === index)
          || (false === this.expandFirstItem && true === this.expandCheckedRadioButton && null !== item.firstElementChild.querySelector('input:checked'))
        ) {
          this.expandedItem = item;
          this.expand();
        } else {
          this.collapse();
        }

        this.reset();
      });
    },
    clickCollapseExpand(event) {
      // disable multi clicks on same button.
      if (false === this.disableMultiToggle && true === event.currentTarget.parentElement.isEqualNode(this.expandedItem)) {
        return;
      }
      this.content = event.currentTarget.nextElementSibling;
      if ('0px' === this.content.style.maxHeight) {
        this.expandedItem = event.currentTarget.parentElement;
        this.expand()
      } else {
        this.collapse();
      }
    },
    reset() {
      this.expandedItem = null;
      this.content = null;
    },
    expand() {
      this.content.style.cssText += `
        opacity: 1;
        pointer-events: auto;
        overflow: unset;
        max-height: unset;
      `;
      this.autoCollapse();
    },
    collapse(element = null) {
      (element ?? this.content).style.cssText += `
        pointer-events: none;
        overflow: hidden;
        opacity: 0;
        max-height: 0px;
      `;
    },
    autoCollapse() {
      Array.from(this.$el.children).forEach(child => {
        if (true === child.isEqualNode(this.expandedItem)) return;
        this.collapse(child.lastElementChild);
      });
    },
  },
  mounted() {
    this.init();
  }
}
</script>
